import logo from './logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          It's a little lonely here, stay tuned for updates!
        </p>
        <a
          className="App-link"
          href="https://play.google.com/store/apps/dev?id=9095864201809739005"
          target="_blank"
          rel="noopener noreferrer"
        >
          My apps on Google Play!
        </a>
      </header>
    </div>
  );
}

export default App;
